import { InviteType } from '../types/invites';

export type InviteEmailCheckResult =
  | { status: 'ok' }
  | {
      status: 'email-mismatch';
      invitedEmail: string;
      currentEmail: string;
      inviteType?: InviteType;
    };

export function checkInviteEmailMismatch(
  invitedEmail?: string | null,
  currentEmail?: string | null,
  inviteType?: InviteType,
): InviteEmailCheckResult {
  if (!invitedEmail || !currentEmail) {
    return { status: 'ok' };
  }

  if (invitedEmail.toLowerCase() !== currentEmail.toLowerCase()) {
    return {
      status: 'email-mismatch',
      invitedEmail,
      currentEmail,
      inviteType,
    };
  }

  return { status: 'ok' };
}
